import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SocialItemPlatform, socialItems } from '@klubovna/shared-models';
import { GtagService } from '@klubovna/shared-data';

@Component({
  selector: 'k-base-screen',
  imports: [],
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseScreenComponent {
  gtagService: GtagService = inject(GtagService);

  socialItems = socialItems;
  socialItemPlatforms = SocialItemPlatform;

  clickEvent(label: string): void {
    this.gtagService.trackEvent('Button', 'Click', label);
  }

  scrollToTop(): void {
    this.gtagService.trackEvent('Button', 'Click', 'scroll_top');

    if (typeof window === 'undefined') {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  scrollToBottom(): void {
    this.gtagService.trackEvent('Button', 'Click', 'scroll_bottom');
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth',
    });
  }
}
